'use client';
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o);
}
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t)
    return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i))
        return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
} return ("string" === r ? String : Number)(t); }
import React from 'react';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import { hexToRgb, rgbToHex, rgbToHsv } from './colorUtils';
var Container = styled(Box)(function (_ref) {
    var theme = _ref.theme;
    return _defineProperty(_defineProperty({
        width: '100%',
        height: 'auto',
        flexShrink: 0,
        display: 'flex',
        gap: '8px',
        marginTop: '16px'
    }, theme.breakpoints.down('md'), {
        // width: '100%',
        maxWidth: '100%',
        flexWrap: 'wrap',
        gap: '6px'
    }), theme.breakpoints.down('sm'), {
        width: '100%',
        height: 'auto',
        flexDirection: 'column',
        gap: '8px',
        marginTop: '12px'
    });
});
var HexField = styled(TextField)(function (_ref3) {
    var theme = _ref3.theme;
    return _defineProperty(_defineProperty({
        width: '104px',
        '& .MuiInputBase-root': {
            height: '40px',
            fontSize: '14px',
            fontFamily: '"Open Sans"'
        },
        '& .MuiInputLabel-root': {
            fontSize: '14px',
            fontWeight: 600,
            fontFamily: '"Open Sans"'
        }
    }, theme.breakpoints.down('md'), {
        width: '100%',
        maxWidth: '104px'
    }), theme.breakpoints.down('sm'), {
        width: '100%',
        height: '36px'
    });
});
var RgbField = styled(TextField)(function (_ref5) {
    var theme = _ref5.theme;
    return _defineProperty(_defineProperty({
        width: '78px',
        '& .MuiInputBase-root': {
            height: '40px',
            fontSize: '14px',
            fontFamily: '"Open Sans"'
        },
        '& .MuiInputLabel-root': {
            fontSize: '14px',
            fontWeight: 600,
            fontFamily: '"Open Sans"'
        }
    }, theme.breakpoints.down('md'), {
        width: 'calc(33% - 4px)',
        maxWidth: '78px'
    }), theme.breakpoints.down('sm'), {
        width: '100%',
        height: '36px'
    });
});
var ColorValuesComp = function ColorValuesComp(_ref7) {
    var values = _ref7.values, onChange = _ref7.onChange;
    var handleHexChange = function handleHexChange(event) {
        var hex = event.target.value;
        if (/^#[0-9A-F]{6}$/i.test(hex)) {
            var rgb = hexToRgb(hex);
            var hsv = rgbToHsv(rgb.r, rgb.g, rgb.b);
            onChange === null || onChange === void 0 || onChange({
                hex: hex,
                rgb: rgb,
                hsv: hsv
            });
        }
    };
    var handleRgbChange = function handleRgbChange(component) {
        return function (event) {
            var value = parseInt(event.target.value);
            if (value >= 0 && value <= 255) {
                var newRgb = _objectSpread(_objectSpread({}, values.rgb), {}, _defineProperty({}, component, value));
                var hex = rgbToHex(newRgb.r, newRgb.g, newRgb.b);
                var hsv = rgbToHsv(newRgb.r, newRgb.g, newRgb.b);
                onChange === null || onChange === void 0 || onChange({
                    hex: hex,
                    rgb: newRgb,
                    hsv: hsv
                });
            }
        };
    };
    return /*#__PURE__*/ React.createElement(Container, null, /*#__PURE__*/ React.createElement(HexField, {
        label: "Hex",
        value: values.hex.toUpperCase(),
        onChange: handleHexChange,
        variant: "outlined",
        size: "small",
        inputProps: {
            maxLength: 7,
            style: {
                fontFamily: '"Open Sans"'
            }
        }
    }), /*#__PURE__*/ React.createElement(RgbField, {
        label: "R",
        type: "number",
        value: values.rgb.r,
        onChange: handleRgbChange('r'),
        variant: "outlined",
        size: "small",
        inputProps: {
            min: 0,
            max: 255,
            style: {
                fontFamily: '"Open Sans"'
            }
        }
    }), /*#__PURE__*/ React.createElement(RgbField, {
        label: "G",
        type: "number",
        value: values.rgb.g,
        onChange: handleRgbChange('g'),
        variant: "outlined",
        size: "small",
        inputProps: {
            min: 0,
            max: 255,
            style: {
                fontFamily: '"Open Sans"'
            }
        }
    }), /*#__PURE__*/ React.createElement(RgbField, {
        label: "B",
        type: "number",
        value: values.rgb.b,
        onChange: handleRgbChange('b'),
        variant: "outlined",
        size: "small",
        inputProps: {
            min: 0,
            max: 255,
            style: {
                fontFamily: '"Open Sans"'
            }
        }
    }));
};
export default ColorValuesComp;
